import { Component, OnInit, Inject, ElementRef, ViewEncapsulation, Input } from '@angular/core';
import { AggregationService } from "../../services/aggregation.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SessionStorageService } from "../../services/web-storage/session-storage.service";
import { PruHttpService } from "../../services/pru-http.service";
import { GenericService } from "../../services/generic.service";
import { NavigationService } from "../../../../node_modules/global-navigation/src/app/services/navigation-service.service";
import { Subscription } from 'rxjs';
declare var environment: any;

@Component({
  selector: "pru-messages",
  templateUrl: "./messages.component.html",
  styleUrls: ["./messages.component.scss"]
})
export class MessagesComponent implements OnInit {
  msgData: any;
  data: any;
  redesign: boolean = false;
  ABClosed: boolean = false;
  showOutage = false;
  outages = [];
  BuCode = [];
  private subscription: Subscription;
  constructor(

    private _aggregationService: AggregationService,
    private _http: HttpClient,
    private _pruhttp: PruHttpService,
    private _sessionStorageService: SessionStorageService,
    private _genericService: GenericService,
    private _navigationService: NavigationService
  ) { }

  ngOnInit() {
    this._genericService.toggleObs$.subscribe((res: any) => {
      this.redesign = res;
    });

    this.subscription = this._aggregationService.aggregationDone.subscribe((res: any) => {
      if (res === "aggregationDone") {
        this.subscription.unsubscribe();
        if (environment.umpire && this._genericService.outage) {

          this._pruhttp.get('/api/co/public/outage/v1/outageservice/outages/features', 'outage').subscribe((res: any) => {
            if (res && res.length > 0) {
              let userBu = this._genericService.userBUs;
              if (userBu.length > 0) {
                userBu.map((bu: string) => {
                  let buName = bu.replace(/\s/, '').toLowerCase();
                  let buoutage = '/availability/' + buName + '/acctdata';
                  this.BuCode.push(buoutage);
                });
                let outageRes = res.filter(item => /open/i.test(item.status) && item['featureCode'] && this.BuCode.includes(item['featureCode']));
                outageRes.map(item => {
                  if (item.outage && item.outage.length > 0) {
                    let outageitem = item.outage[0];
                    try {
                      outageitem.messageContent = JSON.parse(outageitem.messageContent)
                    } catch {
                      outageitem.messageContent = '';
                      console.error('Outage message json parse error')
                    }
                    if (outageitem.messageContent) {
                      this.outages.push(outageitem);
                    }
                  }
                });
              }

              this.showOutage = this.outages.length > 0 ? true : false;
            }
          });
        }


        if (this._sessionStorageService.getItem("userMessages")) {
          this.msgData = this._sessionStorageService.getItem("userMessages", true);
        } else {
          //  let coMessages = this._cookieService.get('coSystemMsg') ? 'nocomessage' : 'CO';
          let entitlement = this._sessionStorageService.getItem("userRoles", true);
          let msgTax = entitlement ? "CO," + entitlement : "CO";
          msgTax = msgTax.replace(/\^|%5E/gi, ",").replace(/\"/gi, '');
          let msgObj = msgTax.split(",").map(item => "UCD_Content/Messages_TX/" + item).join();
          msgObj = this.redesign ? msgObj + ",UCD_Content/Messages_TX/AB_TEST" : msgObj;
          let url = "/wps/wcm/myconnect/ucd_content/sa-messages?source=library&srv=cmpnt&cmpntname=UCD_Design/MENU-HOME1&sitearea=UCD_Content/SA-Messages&cat=" + msgObj;
          /* this._pruhttp.getText(url, "co-bu-msg", "no-headers").subscribe(
            serviceData => {
              this.processData(serviceData);
            },
            err => {
              console.error("serivce BU message error wcm", err);
            }
          ); */
          fetch(url).then(response => response.text())
            .then(response => {
              this.processData(response);
            })
            .catch(err => console.log("fetch msg error: ", err));
        }
      }
    });
  }

  processData(inputdata) {
    let objMessages = [];
    let messagesJSON = {};
    if (inputdata) {
      try {
        let wcmdata = inputdata.replace(/(\r|\n|\t|\f)/g, "")
          .replace(/dir="ltr"/gi, "")
          .replace(/dir=\\"ltr\\"/gi, "")
          .replace(/dir="\\&quot;ltr\\&quot;"/gi, "")
          .replace(/[\u0000-\u0019]+/g, "");
        this.data = JSON.parse(wcmdata);
      } catch (e) {
        console.warn("Msg JSON parsing error: ", e);
        this.data = { content: [] };
      }

      for (let x = 0; x < this.data["content"].length; x++) {
        let msgObj = this.data["content"][x].messages;
        msgObj.closed = false;
        objMessages.push(msgObj);
      }
      messagesJSON = { content: objMessages };
      this.msgData = messagesJSON;
      this._sessionStorageService.setItem("userMessages", messagesJSON, true);

    }

  }

  closeBuMsg(buName: string) {
    if (this.msgData) {
      let msgContent = this.msgData.content;
      if (msgContent && msgContent.length > 0) {
        msgContent.map(item => {
          if (item.buName == buName) {
            item.closed = true;
          }
        });
      }
      this._sessionStorageService.setItem("userMessages", JSON.stringify(this.msgData));
    }
  }
}
